import React from 'react'
import { styled } from '../../../styles'
import { BaseThemeType } from '../../../theme'

type PropTypes = {}

const MainWrapper = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  backgroundColor: '#FAFBFC',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '10px',
  flex: 1,
}))

const FinanceMarketplaceSystemSummary: React.FC<PropTypes> = (props) => {
  return (
    <MainWrapper>
      <div>System Summary</div>
      <div>$11,000</div>
      <div>module description</div>
      <div>Inverter description</div>
      <div>Battery description</div>
      <div>Annaul Savings</div>
    </MainWrapper>
  )
}
export default FinanceMarketplaceSystemSummary
